import React from 'react'
import { Link } from 'react-router-dom';
import { Element } from 'react-scroll';

const HrAgentFooter = () => {
  return (
    <Element
      name="HrAgentFooter"
      className="datatalent-section-gap home-one-cat"
    >
      <div className="container inner about-feature-list">
        <div className="row g-5">
          <div className="col-12 mt-0 px-0 px-md-4 data-policy">
            <h5>Data Policy:</h5>
            <p>
              This tool does not maintain your data in our servers. All information you enter remains within your browser session and is deleted when the session ends.<br></br><br></br>
              To provide AI insights the data you provide in the browser is sent to third-party large language model providers like OpenAI, Gemini solely for generating analysis or responses. These providers process your data in accordance with their own privacy policies.<br></br><br></br>
              For any query/concern please reach out to us at <a href="mailto:contact@m2mtechconnect.com">contact@m2mtechconnect.com</a>
            </p>
          </div>
        </div>
      </div>
    </Element>
  )
}

export default HrAgentFooter;